$( document ).on('turbolinks:load', function() {
	console.log($(window).width());
	/*if ($(window).width() > 767) {
		var a = $(".back-img").height();
		$(".sm-div").height(a);
		$( window ).resize(function() {
			a = $(".back-img").height();
			$(".sm-div").height(a);
		});
	}*/
	$("#btn-show-more-1").click(function () {
		$("#btn-show-more-1").hide();
	});
	$("#btn-show-less-1").click(function(){
		$("#btn-show-more-1").show();
	});
	$("#btn-show-more-2	").click(function () {
		$("#btn-show-more-2").hide();
		$("#btn-show-less-1").hide();
	});
	$("#btn-show-less-2").click(function(){
		$("#btn-show-more-2").show();
		$("#btn-show-less-1").show();
	});
	$("#btn-show-less-3").click(function(){
		$("#btn-show-more-3").show();
		$("#btn-show-less-2").show();
	});
	$("#btn-show-more-3").click(function () {
		$("#btn-show-more-3").hide();
		$("#btn-show-less-2").hide();
	});
	var a = 0;
	$(window).scroll(function() {
		var oTop = $('#client-trade').offset().top - window.innerHeight;
		var offsetTop = $('#client-partners').offset().top - window.innerHeight;
		if (a == 0 && $(window).scrollTop() > oTop ) {
			$('.counter-value').each(function() {
				var $this = $(this),
				countTo = $this.attr('data-count');
				$({someValue: 0}).animate({someValue: countTo}, {
					duration: 5000,
      easing:'swing', // can be anything
      step: function() { // called on every step
          // Update the element's text with rounded-up value:
          $this.text(commaSeparateNumber(Math.round(this.someValue)));
        }
      });
			});
			a = 1;
		}

	});
});
function commaSeparateNumber(val){
	while (/(\d+)(\d{3})/.test(val.toString())){
		val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
	}
	return val;
}


